import { Checkbox, Divider, Group, Paper, Stack, Text } from "@mantine/core";
import { type FC, Fragment } from "react";
import { PurpleIndicator } from "@/sales-tools/micro-learning/components/icons";
import type { EvaluationDetailsBody } from "../api/evaluations/types";

import classes from "./EvaluationPage.module.css";

export interface SalesBehaviorsChecklistProps {
    behaviors: EvaluationDetailsBody[];
}

export const SalesBehaviorsChecklist: FC<SalesBehaviorsChecklistProps> = ({ behaviors }) => (
    <Paper shadow="md" radius="md" p="1rem" w="100%" bg="var(--mantine-color-dark-5)" bdrs="0.75rem" flex="0">
        <Stack gap="sm" mb="sm">
            <Text fw={700} size="sm" c="var(--mantine-color-gray-0)">
                Key Sales Behaviors
            </Text>
            <Group gap="0.5rem" mt="0.25rem" ml="0.25rem">
                <PurpleIndicator fill="var(--mantine-color-asurion-3)" style={{ width: "8px", height: "8px" }} />
                <Text size="0.75rem" c="var(--mantine-color-gray-0)">
                    Dynamic checklist
                </Text>
            </Group>
        </Stack>
        <Stack gap={0}>
            {behaviors.length ? (
                behaviors.map((item, index) => (
                    <Fragment key={item.behavior}>
                        <Divider />
                        <Group py="0.625rem" gap="0.75rem">
                            <Text size="0.875rem" fw="500" c="var(--mantine-color-gray-0)">
                                {index + 1}.
                            </Text>
                            <Text
                                size="0.875rem"
                                flex="1"
                                fw="500"
                                c="var(--mantine-color-gray-0)"
                                className={classes.checklistContent}
                            >
                                {item.behavior}
                            </Text>
                            <Checkbox checked={!!item.behaviorPresent} readOnly={true} size="xs" />
                        </Group>
                    </Fragment>
                ))
            ) : (
                <>
                    <Divider />
                    <Group py="0.625rem">
                        <Text size="sm" flex="1" fw="500" c="var(--mantine-color-gray-0)" fs="italic">
                            No behaviors available
                        </Text>
                    </Group>
                </>
            )}
        </Stack>
    </Paper>
);

export default SalesBehaviorsChecklist;
